import slugify from 'slugify'

export default function getCategoryUrl(category: {_id: string; name: string}, isCPG?: boolean) {
  if (isCPG) {
    return `/pedir/category/${category._id}`
  }

  return `/pedir?categoria=${encodeURIComponent(slugify(category.name, {lower: true}))}`
}
